import { Routes } from "@angular/router";
import { FormEditorComponent } from "./modules/form-builder/pages/form-editor/form-editor.component";
import { RedirectToFormEditorComponent } from "./modules/form-builder/pages/redirect-to-form-editor/redirect-to-form-editor.component";
import { AdminFormViewerComponent } from "./modules/form-builder-viewer/pages/admin-form-viewer/admin-form-viewer.component";


export const routes: Routes = [
    // Use component to redirect because 'redirectTO' remove all query params from url //
    { path: '', component: RedirectToFormEditorComponent, pathMatch: 'full' },
    { path: 'form-builder', component: FormEditorComponent, pathMatch: 'full' },

    // Admin path to preview procedure instances //
    { path: 'form-viewer', component: AdminFormViewerComponent, pathMatch: 'full'},

    // Redirect to FormBuilder if not path exists //
    { path: '**', component: RedirectToFormEditorComponent, pathMatch: 'full' }
]